module.exports = __webpack_public_path__ + "static/media/legal-icon.10837804.svg";